"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#17181A",
    transform: "rotate(-1 -27.03 52.338)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 9.167
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 3.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.111 3.898c.8 1.888.8 3.628 0 5.222m-.024 7.549c1.045 1.735 1.045 3.564 0 5.487m-9.21-9.237c1.933-.936 3.761-.936 5.482 0m7.348.104c2.035-1.026 3.867-1.026 5.499 0m-7.072-8.766c.784-1.339 1.552-1.913 2.305-1.721 1.129.288 1.923 1.986 3.366 3.741 1.443 1.756 2.535 2.627 2.821 4.144.191 1.01-.471 1.562-1.988 1.655M10.72 22.283c-.784 1.34-1.552 1.913-2.304 1.721-1.13-.288-1.924-1.985-3.367-3.741-1.442-1.756-2.534-2.627-2.82-4.144-.192-1.01.47-1.562 1.987-1.655m17.342.256c1.735.701 2.54 1.435 2.415 2.201-.188 1.15-1.81 2.09-3.434 3.68-1.623 1.59-2.396 2.754-3.881 3.171-.99.279-1.644-.299-1.961-1.732M4.008 10.63c-1.402-.664-2.04-1.38-1.915-2.146.188-1.15 1.81-2.089 3.434-3.68 1.623-1.59 2.396-2.753 3.881-3.17.99-.28 1.598.333 1.822 1.835"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgHelp);
var _default = exports["default"] = Memo;